import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AccountManager from 'lib/AccountManager';
import LoadingParticles from 'components/LoadingParticles/LoadingParticles.react';

import ParseApp from 'lib/ParseApp';
import ReactDOM from 'react-dom';
import Sidebar from 'components/Sidebar/Sidebar.react';
import Icon from 'components/Icon/Icon.react';
import NeedRedis from 'components/NeedRedis/NeedRedis.react';
import styles from 'dashboard/Dashboard.scss';
import moment from 'moment';
import { getAvailableParseServerVersions } from 'lib/Constants';

export default class DashboardView extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.getCurrentUser();
  }

  componentDidMount() {
    if (!this.state.currentUser) {
      this.getCurrentUser();
    }
  }

  getCurrentUser() {
    const promiseList = [];

    const currentUserPromise = AccountManager.currentUser().then(({ currentUser, currentCustomer }) => {
      return this.setState({ currentUser, currentCustomer });
    });

    promiseList.push(currentUserPromise);

    return Promise.all(promiseList).then(() => {
      let showNotificationDate = window.localStorage.getItem('NotificationDate');
      const showNotificationDateRedis = window.localStorage.getItem('NotificationDateRedis');

      if (!showNotificationDate) {
        showNotificationDate = moment(new Date()).add(-1, 'days');
      }

      const showNotification = moment().isAfter(showNotificationDate);

      if (
        !this.state.currentUser.backups_enabled &&
        showNotificationDate &&
        showNotification &&
        !!showNotificationDateRedis
      ) {
        setTimeout(() => {
          this.setState({ showBackupsMessage: true });
        }, 1000);
      }
    });
  }

  __handleClick(e, path) {
    e.preventDefault();
    this.props.router.push(path);
  }

  __renderBackupsMessage() {
    const __onCloseClick = () => {
      // Show after 14 days
      const showOnDate = moment(Date.now() + (14 * 24 * 3600 * 1000)).format('YYYY-MM-DD');
      window.localStorage.setItem('NotificationDate', showOnDate);

      ReactDOM.findDOMNode(this.refs.notifyBackups).classList.add(styles.hide);
      Intercom('trackEvent', 'close_backups_enabled_notifications');
    }

    return (
      <div ref="notifyBackups" className={styles.notify}>
        <div>
          Do you backup your data every day? Backup &amp; Save your database with our Automatic Backups. <a href="/backups" onClick={(e) => this.__handleClick(e, 'backups')}>Learn more</a>
        </div>

        <span className={styles.iconClose} onClick={__onCloseClick} >
          <Icon width={16} height={16} name="icon-close" />
        </span>
      </div>
    );
  }

  __renderRedisMessage() {
    const settingsPath = this.context.generatePath('settings/live_queries');
    const __onCloseClick = () => {
      // Show after 1 days
      const showOnDate = moment(Date.now() + (1 * 24 * 3600 * 1000)).format('YYYY-MM-DD');
      window.localStorage.setItem('NotificationDateRedis', showOnDate);

      ReactDOM.findDOMNode(this.refs.notifyRedis).classList.add(styles.hide);
      Intercom('trackEvent', 'close_redis_notifications');
    }

    const __onClick = (e) => {
      e.preventDefault();
      this.props.router.push(settingsPath);
    }

    return (
      <div ref="notifyRedis" className={[styles.notify, styles.o].join(' ')}>
        <div>
          Your app is working on multiple engines with auto-scaling mode &amp; LiveQueries enabled.<br />
          Please review <a href={settingsPath} onClick={__onClick}>Settings</a> for optimal performance.
        </div>

        <span className={styles.snooze} onClick={__onCloseClick}>
          Snooze
        </span>
      </div>
    );
  }


  __renderNotify() {
    let content;
    if (this.state.showBackupsMessage) {
      content = this.__renderBackupsMessage();
    }

    return content;
  }

  __renderSidebar() {
    let sidebarChildren = null;
    if (typeof this.renderSidebar === 'function') {
      sidebarChildren = this.renderSidebar();
    }
    const appSlug = (this.context.currentApp ? this.context.currentApp.slug : '');

    let features = this.context.currentApp && this.context.currentApp.serverInfo && this.context.currentApp.serverInfo.features;

    if (!features) {
      features = {};
    }

    const coreSubsections = [];
    coreSubsections.push({
      name: 'Browser',
      icon: 'icon-db',
      link: '/browser',
    });

    coreSubsections.push({
      name: 'Cloud Code',
      link: '/cloud_code/main.js',
    });

    coreSubsections.push({
      name: 'Webhooks',
      link: '/webhooks',
    });

    coreSubsections.push({
      name: 'Jobs',
      link: '/jobs',
    });

    coreSubsections.push({
      name: 'Logs',
      link: '/logs',
    });

    coreSubsections.push({
      name: 'Config',
      link: '/config',
    });

    coreSubsections.push({
      name: 'API Console',
      link: '/api-console',
    });

    const pushSubsections = [];

    pushSubsections.push({
      name: 'Send New Push',
      link: '/push/new',
    });

    pushSubsections.push({
      name: 'Activity',
      link: '/push/activity/all',
    });

    pushSubsections.push({
      name: 'Audiences',
      link: '/push/audiences',
    });

    // const analyticsSidebarSections = [];

    // analyticsSidebarSections.push({
    //   name: 'Overview',
    //   link: '/analytics/overview',
    // });

    // analyticsSidebarSections.push({
    //   name: 'Explorer',
    //   icon: 'icon-circle-o-right',
    //   link: '/analytics/explorer',
    // });

    // analyticsSidebarSections.push({
    //   name: 'Retention',
    //   link: '/analytics/retention',
    // });

    // analyticsSidebarSections.push({
    //   name: 'Performance',
    //   link: '/analytics/performance',
    // });

    // analyticsSidebarSections.push({
    //   name: 'Slow Queries',
    //   link: '/analytics/slow_queries',
    // });


    const settingsSections = [];

    settingsSections.push({
      name: 'General',
      link: '/settings/general',
    });

    settingsSections.push({
      name: 'Security & Keys',
      link: '/settings/keys',
    });

    settingsSections.push({
      name: 'Users',
      link: '/settings/users',
    });

    settingsSections.push({
      name: 'Push',
      link: '/settings/push',
    });

    settingsSections.push({
      name: 'Emails & Hosting',
      link: '/settings/emails',
    });

    settingsSections.push({
      name: 'Live Queries',
      link: '/settings/live_queries',
    });

    const metricsSubsections = [];
    metricsSubsections.push({
      name: 'Overview',
      link: '/metrics/overview',
    });


    metricsSubsections.push({
      name: 'Requests',
      link: '/metrics/requests',
      // newFeature: true,
    });

    metricsSubsections.push({
      name: 'Traffic',
      link: '/metrics/traffic',
    });

    metricsSubsections.push({
      name: 'Database',
      link: '/metrics/database',
    });

    metricsSubsections.push({
      name: 'Files',
      link: '/metrics/files',
    });

    metricsSubsections.push({
      name: 'Engine',
      link: '/metrics/engine',
      newFeature: true,
    });

    const appSidebarSections = [
      {
        name: 'Getting Started',
        icon: 'icon-getting-started',
        link: '/getting-started',
      },
      {
        name: 'Metrics',
        icon: 'icon-gauges',
        link: '/metrics/overview',
        subsections: metricsSubsections,
      },
    ];

    if (coreSubsections.length > 0) {
      appSidebarSections.push({
        name: 'Core',
        icon: 'icon-rocket',
        link: '/browser',
        subsections: coreSubsections,
      });
    }

    // appSidebarSections.push({
    //   name: 'CDN',
    //   icon: 'icon-cdn',
    //   link: '/cdn',
    // });

    const backupSubsections = [];
    backupSubsections.push({
      name: 'List',
      link: '/backups/list',
    });

    backupSubsections.push({
      name: 'Restore History',
      link: '/backups/restore_history',
    });

    backupSubsections.push({
      name: 'Download History',
      link: '/backups/download_history',
    });


    const runtimeSubsections = [];

    runtimeSubsections.push({
      name: 'Engine',
      link: '/runtime/engine',
      // betaFeature: true,
    });

    runtimeSubsections.push({
      name: 'Builds',
      link: '/runtime/builds',
      // betaFeature: true,
    });

    runtimeSubsections.push({
      name: 'Deployments',
      link: '/runtime/deployments',
      // betaFeature: true,
    });

    runtimeSubsections.push({
      name: 'Environment Variables',
      link: '/runtime/env-variables',
    });

    runtimeSubsections.push({
      name: 'Parse Server Version',
      link: '/runtime/version',
    });

    appSidebarSections.push({
      name: 'Runtime',
      icon: 'icon-runtime',
      link: '/runtime',
      newFeature: true,
      subsections: runtimeSubsections,
    });


    appSidebarSections.push({
      name: 'Automatic Database Backups',
      icon: 'icon-db',
      link: '/backups/list',
      subsections: backupSubsections,
    });

    if (pushSubsections.length > 0) {
      appSidebarSections.push({
        name: 'Push',
        icon: 'icon-push',
        link: '/push/activity/all',
        style: { paddingLeft: '16px' },
        subsections: pushSubsections,
      });
    }

    // if (analyticsSidebarSections.length > 0) {
    //   appSidebarSections.push({
    //     name: 'Analytics',
    //     icon: 'icon-area-chart',
    //     link: '/analytics',
    //     subsections: analyticsSidebarSections,
    //   });
    // }

    if (settingsSections.length > 0) {
      appSidebarSections.push({
        name: 'App Settings',
        icon: 'icon-cogs',
        link: '/settings/general',
        subsections: settingsSections,
      });
    }

    return (
      <Sidebar
        currentUser={this.state.currentUser}
        currentCustomer={this.state.currentCustomer}
        availableParseServerVersions={getAvailableParseServerVersions()}
        router={this.props.router}
        sections={appSidebarSections}
        appSelector
        section={this.section}
        subsection={this.subsection}
        prefix={`/products/apps/${appSlug}`}
        action={this.action}>
        {sidebarChildren}
      </Sidebar>
    );
  }

  /* A DashboardView renders two pieces: the sidebar, and the app itself */
  render() {
    if (!this.state.currentUser || !this.state.currentCustomer) {
      return <LoadingParticles />;
    }

    return (
      <div>
        <div className={styles.content}>
          <div id="c" className={styles.c}>
            {this.renderContent()}
          </div>
          {
            this.__renderNotify()
          }
          <NeedRedis currentApp={this.context.currentApp}>
            {this.__renderRedisMessage()}
          </NeedRedis>
        </div>
        {this.__renderSidebar()}
      </div>
    );
  }
}

DashboardView.contextTypes = {
  generatePath: PropTypes.func,
  currentApp: PropTypes.instanceOf(ParseApp),
};
